import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';

export interface DeleteFlashMessageRequest extends APIRequest
{
    getMsisdn(): string;
}

export class DeleteFlashMessageRequestImpl extends APIRequestDtoImpl implements DeleteFlashMessageRequest
{
    constructor(private msisdn: string)
    {
        super();
    }
    getMsisdn(): string {
        return this.msisdn;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/flashmessage/delete/deleteflashmessagesrequest.tsx